import React, { memo } from 'react';

// Menús destacados obligatorios GOV.CO (Resolución MinTIC 1519/2020, Anexo 2.4).
const MENUS = [
  { id: 'transparencia', label: 'Transparencia y acceso a la información pública', href: 'https://web.icetex.gov.co/transparencia' },
  { id: 'atencion',      label: 'Atención y Servicios a la Ciudadanía',            href: 'https://web.icetex.gov.co/atencion-y-servicios-a-la-ciudadania' },
  { id: 'participa',     label: 'Participa',                                       href: 'https://web.icetex.gov.co/participa' },
];

const InstitutionalMenu = () => {
  return (
    <nav aria-label="Menús destacados GOV.CO" className="w-full bg-cobalt text-white">
      <ul className="max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-wrap items-stretch list-none m-0">
        {MENUS.map((menu) => (
          <li key={menu.id} className="flex">
            <a
              href={menu.href}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-4 py-3 text-sm font-medium text-white/90 hover:text-white hover:bg-white/10 transition-colors no-underline focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-white"
            >
              {menu.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default memo(InstitutionalMenu);
